import { createContext } from 'react';

const CurrentViewportRangeContext = createContext(null);

export { CurrentViewportRangeContext };
